import { createAsyncReducer } from '../../standard-actions/';
import {
    ILoadDomesticRequestActivitiesAction,
    ILoadDomesticRequestActivitiesSuccessAction,
    ILoadDomesticRequestActivitiesErrorAction
} from '../actions/load-domestic-request-activities';
import { IServiceRequestsState } from '../state';
import { initialState } from '../state/initial-state';

export type ServiceRequestActivitiesAction
    = ILoadDomesticRequestActivitiesAction
    | ILoadDomesticRequestActivitiesSuccessAction
    | ILoadDomesticRequestActivitiesErrorAction;

const init = (state: IServiceRequestsState, action: ServiceRequestActivitiesAction) => ({
    ...state,
    serviceRequestDomesticActivities: {
        ...initialState.serviceRequestDomesticActivities,
        status: action.status,
    }
});

const success = (state: IServiceRequestsState, action: ServiceRequestActivitiesAction) => ({
    ...state,
    serviceRequestDomesticActivities: {
        ...initialState.serviceRequestDomesticActivities,
        status: action.status,
        items: (action as ILoadDomesticRequestActivitiesSuccessAction).items
    }
});

const failure = (state: IServiceRequestsState, action: ServiceRequestActivitiesAction) => ({
    ...state,
    serviceRequestDomesticActivities: {
        ...initialState.serviceRequestDomesticActivities,
        status: action.status,
        error: (action as ILoadDomesticRequestActivitiesErrorAction).error
    }
});

const reset = (state: IServiceRequestsState, action: ServiceRequestActivitiesAction) => ({
    ...state,
    serviceRequestDomesticActivities: {
        ...initialState.serviceRequestDomesticActivities,
        status: action.status,
    }
});

export const serviceRequestDomesticActivitiesReducer = createAsyncReducer(initialState, init, success, failure, reset);
